import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox, DatePicker, Dropdown, Input, Menu, Spin, Pagination } from 'antd';
import moment from 'moment';


const tableList = (
  data,
  pageNo,
  dispatch,
  startTime,
  endTime,
  intl,
  meetingReport
) => {
  return data.map((item, index) => {
    return (
      <li key={index}>
        <div
          className={'tip-case reportTable'}
        >
          <div className="meeting-index">{item.holder}</div>
          <div className="meeting-area">{item.name}</div>
          <div className="meeting-name">
            {moment(item.startTime).format('YYYY-MM-DD')}
          </div>
          <div className="meeting-num">
            {moment(item.startTime).format('HH:mm') +
              '-' +
              moment(item.endTime).format('HH:mm')}
          </div>
          <div className="sign-num">{intl.messages.locale === 'en_US'?item.roomNamesEn:item.roomNames}</div>
        </div>
      </li>
    );
  });
};
export default ({ intl, dispatch, loading, meetingReport }) => {
  const {
    startTime,
    endTime,
    userName,
    pageNo,
    searchData,
    pageSize
  } = meetingReport;
  return (
    <div className="message-body report-room report-container">
      {/*标题*/}
     {/* <div className="messages-first">
        <div className="nav">
          <a>{intl.formatMessage({ id: 'report_meeting_list_title' })}</a>
        </div>
      </div>*/}
      {/*主体*/}
      <div className="meeting-report-container">
        <Spin spinning={loading} size="large">
          {/*查询*/}
          <div className="messages-list roomReport room-report-title">
            <div className="messages-title roomReport-head">
              <div className="report-div report-meeting-name">
                <label className="report-search-label">
                  {intl.formatMessage({ id: 'report_holder_name' })}
                </label>
                <Input
                  placeholder={intl.formatMessage({ id: 'report_pls_holder_f' })}
                  value={userName}
                  onChange={e => {
                    dispatch({
                      type: 'meetingReport/setState',
                      payload: { userName: e.target.value }
                    });
                  }}
                />
              </div>
              <div className="report-div report-date">
                <label className="report-search-label" >
                  {intl.formatMessage({ id: 'report_date' })}
                </label>
                <div>
                  <DatePicker
                    allowClear={false}
                    value={startTime}
                    disabledDate={current => {
                      return (
                        current &&
                        current.startOf('day').valueOf() <= moment().endOf('day').valueOf()
                      );
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'meetingReport/setState',
                        payload: { startTime: e }
                      });
                    }}
                  />
                  ~
                  <DatePicker
                    allowClear={false}
                    disabledDate={current => {
                      return (
                        startTime.valueOf() > current.valueOf() ||
                        current.startOf('day').valueOf() <= moment().startOf('day').valueOf()
                      );
                    }}
                    value={endTime}
                    onChange={e => {
                      dispatch({
                        type: 'meetingReport/setState',
                        payload: { endTime: e }
                      });
                    }}
                  />
                </div>
              </div>
              <div className="report-div report-btn-group">
                <button
                  className="button_primary"
                  onClick={() => {
                    dispatch({ type: 'meetingReport/search' });
                  }}
                >
                  <FormattedMessage id="report_search" />
                </button>
                <button
                  onClick={() => {
                    dispatch({ type: 'meetingReport/downloadRoom' });
                  }}
                >
                  <FormattedMessage id="report_download" />
                </button>
              </div>
            </div>
          </div>


          <div
            className="messages-list roomReport room-report-table"
            style={{ minHeight: '620px' }}
          >
            <div
              className={'tip-case reportTable'}
            >
              <div className="meeting-index">
                {intl.formatMessage({
                  id: 'meeting_reserve_message_mail_webex_holder'
                })}
              </div>
              <div className="meeting-area">
                {intl.formatMessage({
                  id: 'meeting_reserve_message_mail_webex_name'
                })}
              </div>
              <div className="meeting-name">
                {intl.formatMessage({ id: 'report_meeting_date' })}
              </div>
              <div className="meeting-num">
                {intl.formatMessage({ id: 'report_meeting_time' })}
              </div>
              <div className="sign-num">
                {intl.formatMessage({ id: 'main_meeting_room' })}
              </div>
            </div>
            <ul
              className={
                searchData.list == undefined
                  ? ''
                  : searchData.list.length == 0
                    ? 'emptyData'
                    : 'messages'
              }
            >
              {searchData.list == undefined
                ? ''
                : searchData.list.length == 0
                  ? intl.formatMessage({ id: 'smart_device_drop_down_no_data' })
                  : ''}
              {searchData.list &&
                tableList(
                  searchData.list,
                  pageNo,
                  dispatch,
                  startTime,
                  endTime,
                  intl,
                  meetingReport
                )}
            </ul>
            <div className="page-cont" >
              {searchData.list &&
                searchData.list.length > 0 && (
                  <Pagination
                    total={searchData.total || 0}
                    showQuickJumper
                    showSizeChanger
                    pageSize={pageSize || 10}
                    current={pageNo || 1}
                    onShowSizeChange={(page, pageSize) => {
                      dispatch({
                        type: 'meetingReport/changePage',
                        payload: { pageNo: page, pageSize: pageSize}
                      });
                    }}
                    onChange={(page, pageSize) => {
                      dispatch({
                        type: 'meetingReport/changePage',
                        payload: { pageNo: page, pageSize: pageSize}
                      });
                    }}
                  />
                )}
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/MeetingReport.js